var _rect, _path, _path2, _rect2, _path3, _rect3, _rect4, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 50,
    viewBox: "0 0 116 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.1579,
    width: 101.316,
    height: 26.3158,
    rx: 2,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5789 25H88.1579V37.1053C88.1579 39.8667 85.9193 42.1053 83.1579 42.1053H56.5789V25Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4211 44.1052C43.4211 43.0007 44.3165 42.1052 45.4211 42.1052H68.7522V46.6842C68.7522 47.7887 67.8567 48.6842 66.7522 48.6842H45.4211C44.3165 48.6842 43.4211 47.7887 43.4211 46.6842V44.1052Z",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.7895,
    y: 29.7921,
    width: 6.57895,
    height: 18.4211,
    rx: 2,
    transform: "rotate(-7.37627 40.7895 29.7921)",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4737 28.6843H45.3684C46.473 28.6843 47.3684 29.5798 47.3684 30.6843V33.2633C47.3684 34.3678 46.473 35.2633 45.3684 35.2633H14.4737V28.6843Z",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1562,
    y: 27.6316,
    width: 6.57895,
    height: 19.7368,
    rx: 2,
    transform: "rotate(50.167 15.1562 27.6316)",
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.921041,
    y: 38.1578,
    width: 6.57895,
    height: 11.8421,
    rx: 2,
    fill: "#D9D9D9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.474,
    cy: 13.1579,
    rx: 1.31579,
    ry: 6.57895,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/Battery.6db55804bef72e7595a662f901c7dc9e.svg";
export { ForwardRef as ReactComponent };